/// <amd-module name="VSSUI/Components/IdentityCard/DefaultSimpleCard" />
import * as React from "react";
import { FocusZoneContext } from "VSSUI/FocusZone";
import { Persona } from "../Persona/Persona";
import { PersonaSize } from "../Persona/Persona.Props";
import { IContactCardProps } from "./ContactCard.Props";

export const DefaultSimpleCard: React.FunctionComponent<IContactCardProps> = (props: IContactCardProps) => {
    const mainIdentityData = {
        imageUrl: props.identity.image,
        primaryText: props.identity.displayName,
        secondaryText:
            props.identity.scopeName && props.identity.signInAddress
                ? props.identity.scopeName + "\\" + props.identity.signInAddress
                : props.identity.signInAddress
                ? props.identity.signInAddress
                : ""
    };

    return (
        <FocusZoneContext.Consumer>
            {(zoneContext): JSX.Element => {
                return (
                    <div className="bolt-identity-default-card-simple bolt-identity-card-content flex-row scroll-hidden">
                        <div className="flex-row flex-grow">
                            <Persona className="bolt-identity-card-persona-main" identity={props.identity} size={PersonaSize.size72} />
                            <div className="bolt-identity-card-persona-text flex-column flex-grow">
                                <div className="primary-text flex-row title-s" tabIndex={0} data-focuszone={zoneContext.focuszoneId}>
                                    {mainIdentityData.primaryText}
                                </div>
                                {mainIdentityData.secondaryText === "" ? (
                                    undefined
                                ) : (
                                    <div className="secondary-text flex-row body-l">{mainIdentityData.secondaryText}</div>
                                )}
                            </div>
                        </div>
                    </div>
                );
            }}
        </FocusZoneContext.Consumer>
    );
};
